module.exports = __webpack_public_path__ + "static/img/2s-info-b1.7353a90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/2s-info-b1.jpg
// module id = l7lX
// module chunks = 0